import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { userAdminQueries } from "../../../features/user-admin/api/user-admin.queries";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  customerId: z.string().optional(),
});

/**
 * @purpose Find a user and manage their access
 * @primary Users table
 * @persona paola-admin-belora, danilo-tech
 */
export const Route = createFileRoute("/app/admin/users/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(userAdminQueries.list()),
});
